var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 60,
    viewBox: "0 0 82 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38768 0H75.6123C79.1775 0 82 2.91771 82 6.43391V53.5661C82 57.1571 79.1033 60 75.6123 60H6.38768C2.89674 60 0 57.1571 0 53.5661V6.43391C0 2.84289 2.89674 0 6.38768 0V0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0235 22.3691C77.0235 18.404 73.8296 15.1122 69.893 15.1122H43.7481V29.626H69.893C73.8296 29.626 77.0235 26.409 77.0235 22.3691V22.3691ZM77.0235 37.7058C77.0235 33.7407 73.8296 30.4489 69.893 30.4489H43.7481V44.9626H69.893C73.8296 44.9626 77.0235 41.7457 77.0235 37.7058C77.0978 37.7806 77.0978 37.7058 77.0235 37.7058V37.7058ZM24.0651 30.4489V29.626H43.2282V28.429C43.2282 21.1721 37.3604 15.2619 30.1557 15.2619H17.9746C10.7699 15.2619 4.97637 21.0225 4.9021 28.2793V31.8703C4.9021 39.1272 10.7699 45.0374 17.9746 45.0374H30.1557C37.3604 45.0374 43.2282 39.1272 43.2282 31.8703V30.4489H24.0651V30.4489Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 41,
    y1: 0,
    x2: 41,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#049696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#207DA9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCb);
export default __webpack_public_path__ + "static/media/CB.0f72507f75dfb0796701bca7d0d282ab.svg";
export { ForwardRef as ReactComponent };